isEventsPage